import { render, staticRenderFns } from "./AdminTrials.vue?vue&type=template&id=ce952808&scoped=true&"
import script from "./AdminTrials.vue?vue&type=script&lang=ts&"
export * from "./AdminTrials.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTrials.vue?vue&type=style&index=0&id=ce952808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce952808",
  null
  
)

export default component.exports